import { Link } from "wouter";

type BrandLockupProps = {
  className?: string;
  ariaLabel?: string;
};

export default function BrandLockup({ className = "", ariaLabel = "Home, Twice home" }: BrandLockupProps) {
  return (
    <Link href="/" className={`brand-lockup ${className}`.trim()} aria-label={ariaLabel}>
      <span className="brand-mark" aria-hidden="true"><span /></span>
      <span className="brand-wordmark">
        <span>Home, <em>Twice</em></span>
        <span className="brand-publisher">Kwaderno &amp; Co.</span>
      </span>
    </Link>
  );
}
